module.exports = {
  email: 'yasser.namez3@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/yassernamez03',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/yasser-namez/',
    },
    {
      name: 'YouTube',
      url: 'https://www.youtube.com/@mighty_programmer',
    },
    {
      name: 'Twitter',
      url: 'https://x.com/NamezYasse4803',
    },
    {
      name: 'Medium',
      url: 'https://medium.com/@yasser.namez',
    },
    {
      name: 'Letterboxd',
      url: 'https://letterboxd.com/mightymouse007/',
    },
  ],

  navLinks: [
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#8EB69B',
    navy: '#051F20',
    darkNavy: '#051F20',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '50px',
    duration: 800,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 0.9,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
